
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {}
})
export default class FiltersMenu extends Vue {
  @Prop() filtersTitle!: string;
  @Prop() filtersDesription!: string;
  @Prop() filterInfo!: boolean;
  @Prop() filtersArray!: any[];
  @Prop() paymentMenu!: boolean;
  @Prop() mutationFunc!: string;
  @Prop() paymentType!: 'Hourly' | 'Daily';
  @Prop() pathName!: string;
  @Prop() distanceValue!: number;
  @Prop() selectedFilters!: number[];

  activeFilters: number[] = [];

  get providerTypeFilters() {
    return {
      providerTypes: this.activeFilters,
      distance: this.distanceValue
    };
  }

  mounted() {
    this.initializeFilters();
  }

  @Watch('selectedFilters', { immediate: true })
  onSelectedFiltersChange(newVal: number[] | undefined) {
    this.activeFilters = Array.isArray(newVal) ? [...newVal] : [];
  }

  initializeFilters() {
    if (this.selectedFilters) {
      this.activeFilters = [...this.selectedFilters];
    }
  }

  toggleFilter(id: number) {
    this.activeFilters.includes(id)
      ? this.activeFilters.splice(this.activeFilters.indexOf(id), 1)
      : this.activeFilters.push(id);
  }

  sendDataToBack() {
    const dataToSend = this.mutationFunc === 'ProviderTypes' ? this.providerTypeFilters : this.activeFilters;
    if (this.mutationFunc === 'ProviderTypes') {
      this.$store.commit(`waitlistStore/set${this.mutationFunc}`, dataToSend);
    } else if (this.paymentType === 'Daily' || this.paymentType === 'Hourly') {
      this.$store.commit('waitlistStore/setPaymentOptions', {
        componentId: this.paymentType,
        paymentOptions: dataToSend
      });
    } else {
      this.$store.commit(`waitlistStore/set${this.mutationFunc}`, dataToSend);
    }
  }

  selectFilterItem(idx: number) {
    this.$emit('filter-item-selected', idx);
  }
}
